"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildObjectSifter = exports.rulesToSifterRules = exports.ruleToSifterRule = void 0;
const sift_1 = __importDefault(require("sift"));
function isNestedFilterRule(rule) {
    return 'rules' in rule;
}
/**
 * Deep walks a filter rule and replaces instances of the `criteria` property
 * with a compiled sift function which produces a SifterRule.
 */
function ruleToSifterRule(rule) {
    if (isNestedFilterRule(rule)) {
        return {
            comment: rule.comment,
            criteria: (0, sift_1.default)(rule.criteria),
            rules: rulesToSifterRules(rule.rules),
        };
    }
    else {
        if ('percent' in rule) {
            return {
                comment: rule.comment,
                action: rule.action,
                criteria: (0, sift_1.default)(rule.criteria),
                percent: rule.percent,
            };
        }
        else {
            return {
                comment: rule.comment,
                action: rule.action,
                criteria: (0, sift_1.default)(rule.criteria),
            };
        }
    }
}
exports.ruleToSifterRule = ruleToSifterRule;
/**
 * Converts and array of JSON filter rules into SifterRules where any criteria
 * properties have been converted to sift filters.
 */
function rulesToSifterRules(rules) {
    return rules.map(ruleToSifterRule);
}
exports.rulesToSifterRules = rulesToSifterRules;
/**
 * Converts the criteria property of each FilterRule object into a sift filter
 * for use in filtering objects.
 */
function buildObjectSifter(rules) {
    return {
        rules: rulesToSifterRules(rules.rules),
    };
}
exports.buildObjectSifter = buildObjectSifter;
//# sourceMappingURL=buildEventSifter.js.map